import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../../consts/Constants.js";
import Style from "../../../../../styles/js/StyleCallList.js";
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';

import CircularProgressWithLabel from "../../../../../components/common/CircularProgressWithLabel.js";
import CircularProgress from '@mui/material/CircularProgress';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ConfirmIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import { createByteArray } from "../../../../../plas/utils";

import service from "../../../../../plas/services/calls/service.jsx";
import alerter from "../../../../alerts/alerter";

export default function FormInput( { form, input, disable, disabled } ) {

  const style = Style();

  const [editing, setEditing] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);
  const [downloadingA, setDownloadingA] = React.useState({}); // Descargas de auxiliary files
  const [actualInput, setActualInput] = React.useState(input);
  const [originalInput, setOriginalInput] = React.useState(input);
  const [fileToDelete, setFileToDelete] = React.useState(null);
  const [progress, setProgress] = React.useState(null);
  const inputFile = React.useRef(null) 

  useEffect(() => { 
    setActualInput(input);
    setOriginalInput(input);
  }, [input] )

  const startEditing = () => {
    setEditing(true);
  }

  const stopEditing = () => {
    setActualInput(originalInput);
    setEditing(false);
  }

  const saveChanges = () => {
    setUpdating(true);
    disable(true);

    var newInput = { configurationId: form.id, id: actualInput.id, name: actualInput.name, description: actualInput.description }
    service.api.inputs.update(newInput, (response) => {
      if (response.error == null) {
        setEditing(false);
        input.name = actualInput.name;
        input.description = actualInput.description;
        setOriginalInput(actualInput);
      } else {
        alerter.showError(response.error);
      }
      setUpdating(false);
      disable(false);
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setActualInput({ ...actualInput, [name]: value });
  };

  const onButtonClick = () => {
    inputFile.current.click();
  }

  const onSelectFile = (event, input) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];

    var bin = {
        name: file.name,
        type: file.type,
        data: createByteArray(URL.createObjectURL(file))
    }

    disable(true);

    service.api.auxiliaryFiles.create(form.id, input.id, bin, {
      onUpdateProgress: (progressValue) => { setProgress(progressValue) },
      result: (response) => {
        if (response.result != null) {

          input.addAuxiliaryFile(response.result);
          setActualInput(input);
          setOriginalInput(input);
        } else {
          alerter.showError(response.error);
        }
        setProgress(null);
        setFileToDelete(null);
        disable(false);
      }
    });
  }

  const onRemoveFile = (file) => {
    setFileToDelete(file.id);
    disable(true);

    service.api.auxiliaryFiles.delete(form.id,input.id,file.id, (response) => {
      setProgress(null);
      setFileToDelete(null);

      if (response.result != null) {
        input.removeAuxiliaryFile(file);
      } else {
        alerter.showError(response.error);
      }

      setActualInput(input);
      setOriginalInput(input);
      disable(false);
    });   
  }

  const getAuxiliaryFile = (form, input, file) => {
    
    setDownloadingA(prevState => {
      const state = { ...prevState };
      state[file.id] = 0;
      return state;
    });

    service.api.auxiliaryFiles.get(form.id,input.id,file.id, {
      success: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      },
      error: () =>  { 
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = undefined;
          return state;
        });
      } ,
      onDownloadProgress: (value) => {
        setDownloadingA(prevState => {
          const state = { ...prevState };
          state[file.id] = value;
          return state;
        });
      }
    });
  }

  return (
    <div className={style.row}>
      { actualInput != null ? (
        <Card>
          <div>
            <div className={style.itemHeader} >
              <Typography className={style.titleInitial}>
                Campo #{actualInput.position+1}
              </Typography>
              <div style={{ marginLeft: 'auto' }} >
                { updating ? 
                  (
                    <IconButton disabled={true} aria-label="delete" style={{ color: 'white' }}>
                     <CircularProgress color="inherit" size={22}/>
                    </IconButton>
                  ) : (
                    <div>
                      { editing ? 
                        (
                          <div>
                            <Tooltip title="Cancelar">    
                              <IconButton disabled={disabled} aria-label="cancel" style={{ color: 'white' }} onClick={ () => { stopEditing() }}>
                                <CancelIcon font-size="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip disabled={disabled} title="Confirmar">    
                              <IconButton aria-label="confirm" style={{ color: 'white' }} onClick={ () => { saveChanges() }}>
                                <ConfirmIcon font-size="small"/>
                              </IconButton>
                            </Tooltip>
                          </div>
                        ) : 
                        ( 
                          <div>
                            { form.isEditable() ? 
                              (
                                <Tooltip title="Editar">    
                                  <IconButton disabled={disabled} aria-label="edit" style={{ color: 'white' }} onClick={ () => { startEditing() }} >
                                    <EditIcon font-size="small"/>
                                  </IconButton>
                                </Tooltip>
                              ) : (null)
                            }
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
            <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign: "left"}}>
              <div className={style.itemContent} style={{whiteSpace: "pre-line"}}>
                <Stack style={{marginTop: "10px"}} spacing={2}> 
                  <TextField
                    variant="outlined" 
                    id="name"
                    label="Nombre"
                    name="name"
                    value={actualInput.name}
                    onChange={handleChange}
                    placeholder="Nombre del formulario"
                    disabled={!editing}/>
                  <TextField
                    variant="outlined" 
                    id="description"
                    label="Descripción"
                    name="description"
                    multiline
                    value={actualInput.description}
                    placeholder="Breve descripción del formulario"
                    onChange={handleChange}
                    disabled={!editing}/>
                </Stack>
              </div>
            </div>
            { (form.isEditable() || actualInput.auxiliaryFiles.length !== 0) ?
              (<div style={{ overflow: 'auto', paddingLeft: "12px", paddingRight: "12px", textAlign: "left" }}>
                <div className={style.itemContent}>
                    <Stack style={{marginTop: "10px"}} direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
                      <Typography style={{display:"flex", justifyContent:"center", alignItems:"center", textAlign:"center", width: "70px"}}>
                        Archivos<br/>auxiliares
                      </Typography>
                      { actualInput.auxiliaryFiles.map((file) => (
                          fileToDelete !== file.id ?                         
                            (
                              <div>
                              { downloadingA[file.id] !== undefined ? 
                                (
                                <Stack alignItems="center" style={{width:"110px"}}>
                                  <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={downloadingA[file.id]} />
                                </Stack>)
                                :(
                                <Stack alignItems="center" style={{width:"110px"}}>
                                <IconButton size="large" width="50px"  height="50px" onClick={ () => { getAuxiliaryFile(form,input,file); }} >
                                  <FilePresentIcon fontSize="inherit" />
                                </IconButton>
                                <Tooltip title={file.bin.name}>
                                    <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center", overflow:"hidden"}}>{file.bin.name}</span>
                                </Tooltip>
                                { form.isEditable() ? 
                                (<Tooltip title="Borrar">
                                  <IconButton disabled={disabled} size="small" onClick={ () => { onRemoveFile(file) }}>
                                    <DeleteForeverIcon fontSize="inherit" />
                                  </IconButton>
                                </Tooltip>) : (null)
                                }
                                </Stack>)
                              }
                              </div>
                            ) :
                            (<Stack alignItems="center" style={{width:"110px"}}>
                              <CircularProgress style={{color:Constants.COLOR_PRIMARY}} />
                            </Stack>)
                        ))
                      }
                      { progress == null ? 
                        (<div>
                          { form.isEditable() ? (
                            <Stack alignItems="center" style={{width:"110px"}}>
                              <IconButton disabled={disabled} onClick={onButtonClick} size="large" width="50px"  height="50px" >
                                <UploadFileIcon fontSize="inherit" />
                                <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={ (event) => onSelectFile(event,actualInput) }/>
                              </IconButton>
                              <span style={{fontSize:"14px", textOverflow: "ellipsis", whiteSpace:"nowrap", width:"100%", textAlign:"center"}}>Subir archivo</span>
                            </Stack>) : (null)
                          }
                        </div>) : 
                        (<Stack alignItems="center" style={{width:"110px"}}>
                          <CircularProgressWithLabel style={{width:"35px", height:"35px" }} value={progress} />
                        </Stack>)
                      }
                    </Stack>
                </div>
              </div>) : (null)
            }

          </div>
        </Card>) : (null)
      }
    </div>
    
  );
}
